import request from "./request";

import wxRequest from "./wxRequest";

const http ={
  /**
   * @param type 请求方式
   * @param url 请求地址
   * @param params 请求参数
   * @param data 请求body
   */
	httpRequest(url,type,params){
	    const config = {
	      method: type,
	      url:url
	    }
	    if(params) config.params = params
	    return request(config)
	  },
	  wxHttpRequest(url,type,params){
	    const config = {
	      method: type,
	      url:url
	    }
	    if(params) config.params = params
	    return wxRequest(config)
	  }
}
export default http